import { Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
    OpportunityType,
    opportunityTypeGoalBgColourMap,
    opportunityTypeGoalColourMap,
    opportunityTypeIconMap,
    opportunityTypeSymbolMap,
    OpportunityView,
} from '../../../coaching-base/opportunity';
import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { Opportunity } from '../models/oa.model';

const opportunityTypeTranslationMap: { [key in OpportunityType]: string } = {
    [OpportunityType.PENDING]: TranslationKeyMap._7502_PENDING_GOAL,
    [OpportunityType.COMPONENT]:
        TranslationKeyMap._7501_COACHING_ON_COMPONENT_METRIC,
    [OpportunityType.ACTIVE]: TranslationKeyMap._767___TO_GOAL,
    [OpportunityType.CLOSED_STILL_OPP]:
        TranslationKeyMap._7498_CLOSED_GOAL_STILL_AN_OPPORTUNITY,
    [OpportunityType.NO_GOAL]: TranslationKeyMap._7489_UNCOACHED,
    [OpportunityType.CLOSED_NOT_OPP]:
        TranslationKeyMap._7499_CLOSED_GOAL_NO_LONGER_AN_OPPORTUNITY,
    [OpportunityType.MISSED]: TranslationKeyMap._9823_ACTION_REQUIRED_ON_GOAL,
    [OpportunityType.MISSED_EXPIRED]:
        TranslationKeyMap._7508_MISSED_OPPORTUNITIES,
};

@Component({
    selector: 'oa-legend',
    templateUrl: './oa-legend.component.html',
})
export class OALegendComponent {
    @ViewChild('OALegendBtnProp', { static: true }) OALegendBtnProp: ElementRef;

    /** @private */
    _opportunityTypeTranslationMap = opportunityTypeTranslationMap;

    ngAfterViewInit(): void {
        this.OALegendBtnProp.nativeElement.innerHTML = this.getOALegend();
    }

    i18n = TranslationKeyMap;
    OALegendBtn: string;
    opportunityType = OpportunityType;

    oportunitiesArray: Opportunity[] = [];

    constructor(protected _translateService: TranslateService) {}

    ngOnInit(): void {
        this.getOALegendTwo();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getOALegendTwo() {
        const oppTypes = [
            OpportunityType.CLOSED_STILL_OPP,
            OpportunityType.CLOSED_NOT_OPP,
            OpportunityType.NO_GOAL,
            OpportunityType.ACTIVE,
            OpportunityType.PENDING,
            OpportunityType.COMPONENT,
            OpportunityType.MISSED,
            OpportunityType.MISSED_EXPIRED,
        ];
        for (const el of oppTypes) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const oppObject: Opportunity = { view: {} as OpportunityView };

            const colour = opportunityTypeGoalBgColourMap[el];
            const labelColour = opportunityTypeGoalColourMap[el];
            const icon = opportunityTypeIconMap[el];
            const symbol = opportunityTypeSymbolMap[el];

            oppObject.view.goalColour = colour;
            oppObject.view.goalLabelColour = labelColour;
            oppObject.view.goalIcon = icon;
            oppObject.view.oppType = el;

            if (el === OpportunityType.PENDING) {
                oppObject.view.goalLabel = symbol;
            }
            if (el === OpportunityType.COMPONENT) {
                oppObject.view.goalLabel = symbol;
                oppObject.view.goalBadgeLabel = '2';
                // oppObject.coachedComponents = [];
                // oppObject.coachedComponents.push({} as any as Opportunity, {} as any as Opportunity);
            }
            if (el === OpportunityType.ACTIVE) {
                oppObject.view.goalColour = '#137e0f'; // see opportunityTypeGoalBgColourMap:OpportunityType.CLOSED_NOT_OPP
                oppObject.percentToGoal = oppObject.view.percentToGoal = 99;
                oppObject.actual = 1;
            }
            if (
                el !== OpportunityType.PENDING &&
                el !== OpportunityType.COMPONENT &&
                el !== OpportunityType.ACTIVE
            ) {
                oppObject.view.goalLabel = null;
                oppObject.view.percentToGoal = null;
            }

            this.oportunitiesArray.push(oppObject);
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getOALegend() {
        // this.OALegendBtnCopy = 'metric';
        // this.OALegendPercentToTarget = '% to Target';
        // this.OALegendContentList = 'Uncoached';
        /* eslint-disable @typescript-eslint/restrict-template-expressions */
        this.OALegendBtn = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 546.2 225.5" style="enable-background:new 0 0 546.2 225.5;" xml:space="preserve">
            <style type="text/css">
                .st0{fill:none;stroke:#B5B5B5;stroke-miterlimit:10;}
                .st1{fill:none;stroke:#BABABA;stroke-miterlimit:10;}
                .st2{fill:none;stroke:#666666;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:5;}
                .st3{fill:#78A746;}
                .st4{fill:#52433C;}
                .st5{font-family:'Lato-Regular';}
                .st6{font-size:27.2853px;}
                .st7{fill:#606060;}
                .st8{font-family:'Lato-Bold';}
                .st9{font-size:28.056px;}
            </style>
            <g id="Layer_1">
                <title>legend-button</title>
                <g>
                    <g id="Button">
                        <circle class="st0" cx="66.7" cy="116.7" r="41.8"/>
                    </g>
                    <g id="button-border">
                        <path id="background" class="st1" d="M543.6,174.2H2.5c-1.1,0-2-0.9-2-2V61.8c0-1.1,0.9-2,2-2h541.2c1.1,0,2,0.9,2,2v110.3
                            C545.7,173.3,544.7,174.2,543.6,174.2z"/>
                        <circle class="st2" cx="66.7" cy="117" r="47.2"/>
                        <circle class="st2" cx="173.7" cy="117" r="47.2"/>
                        <path class="st2" d="M520.9,156.9H362.7c-2.8,0-5-2.2-5-5V82.1c0-2.8,2.2-5,5-5h158.2c2.8,0,5,2.2,5,5v69.8
                            C525.9,154.7,523.6,156.9,520.9,156.9z"/>
                        <line class="st2" x1="65.4" y1="167.9" x2="65" y2="222.9"/>
                        <polyline class="st2" points="175.6,66.3 190.8,14 234.2,14 			"/>
                    </g>
                    <g id="Number">
                        <path class="st3" d="M165.8,99.5v2.5c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.4-0.3,0.8-0.5,1.2l-13,26.7c-0.3,0.5-0.6,1-1.1,1.4
                            c-0.6,0.4-1.3,0.6-2,0.6h-4.2l13.3-26.2c0.5-1,1.1-1.9,1.8-2.8h-16.4c-0.3,0-0.7-0.1-0.9-0.4c-0.3-0.2-0.4-0.6-0.4-0.9v-4h23.6
                            L165.8,99.5z"/>
                        <path class="st3" d="M173.3,129.3h6.9v-20c0-0.8,0-1.6,0.1-2.4l-4.9,4.1c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.1-0.6,0.1
                            c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.6-0.5l-1.8-2.5l10.4-8.9h4.8v29.9h6.2v4.4h-19L173.3,129.3L173.3,129.3z"/>
                        <path class="st3" d="M202.3,117.7c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.6,0.5-1,0.7s-0.8,0.2-1.2,0.2
                            s-0.8-0.1-1.2-0.2s-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.7-0.6-1.1c-0.2-0.4-0.2-0.9-0.2-1.4s0.1-1,0.2-1.5c0.2-0.4,0.4-0.7,0.6-1.1
                            c0.3-0.3,0.6-0.5,1-0.7s0.8-0.2,1.2-0.2s0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.7,0.6,1.1
                            C202.2,116.6,202.3,117.1,202.3,117.7z M207.1,114.8l0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.1h1.2l-10,13.4l-0.2,0.2
                            c-0.1,0.1-0.2,0.1-0.3,0.1h-1.3L207.1,114.8z M201,117.7c0-0.4,0-0.7-0.1-1.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.2-0.3-0.3-0.5-0.4
                            c-0.5-0.1-0.9-0.1-1.4,0c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.4-0.1,0.7-0.1,1.1s0,0.7,0.1,1.1
                            c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.2,0.3,0.3,0.5,0.4c0.5,0.1,0.9,0.1,1.4,0c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.4,0.4-0.7
                            C201,118.4,201,118,201,117.7L201,117.7z M209.9,124.9c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.6,0.5-1,0.7
                            c-0.4,0.2-0.8,0.2-1.2,0.2s-0.8-0.1-1.2-0.2c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.7-0.6-1.1c-0.2-0.4-0.2-0.9-0.2-1.4
                            s0.1-1,0.2-1.5c0.2-0.4,0.4-0.7,0.6-1.1c0.3-0.3,0.6-0.5,1-0.7s0.8-0.2,1.2-0.2s0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7
                            c0.3,0.3,0.5,0.7,0.6,1.1C209.8,123.8,209.9,124.3,209.9,124.9L209.9,124.9z M208.6,124.9c0-0.4,0-0.7-0.1-1.1
                            c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.2-0.3-0.3-0.5-0.4s-0.5-0.1-0.7-0.1s-0.5,0-0.7,0.1s-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.7
                            c-0.1,0.7-0.1,1.5,0,2.2c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.2,0.3,0.3,0.5,0.4s0.5,0.1,0.7,0.1s0.5,0,0.7-0.1s0.4-0.2,0.5-0.4
                            c0.2-0.2,0.3-0.4,0.4-0.7C208.5,125.7,208.6,125.2,208.6,124.9L208.6,124.9z"/>
                    </g>
                </g>
            </g>
            <g id="Copy">
                <text transform="matrix(1 0 0 1 387.34 126.74)" class="st4 st5 st6 oa-legend-btn-copy">${this._translateService.instant(
                    TranslationKeyMap._713_METRIC,
                )}</text>
                <text transform="matrix(1 0 0 1 236.69 24.17)" class="st7 st8 st9"> ${this._translateService.instant(
                    TranslationKeyMap._768___TO_TARGET,
                )}</text>
            </g>
        </svg>`;
        return this.OALegendBtn;
    }
}
